export default "__VITE_ASSET__BHAAFMX0__"